//Slider iconos home
const swiper = new Swiper('.swiper1', {
  slidesPerView: 'auto', 
  spaceBetween: 30,
  watchOverflow: true, 
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

//Slider productos MA home
const swiper2 = new Swiper('.swiper2', {
  slidesPerView: 2, 
  spaceBetween: 5.5,
  watchOverflow: true, 
  autoHeight: false,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 15,
      watchOverflow: true, 
    },
    1024: {
      slidesPerView: 'auto',
      spaceBetween: 15,
      watchOverflow: true, 
    },
  },
});

//Slider testimonios veterinarios
const swiper3 = new Swiper('.swiper3', {
  spaceBetween: 38,
  slidesPerView: 1.5,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    390: {
      slidesPerView: 1.5,
      spaceBetween: 36,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 36
    },
    930: {
      slidesPerView: 'auto',
      watchOverflow: true,
    }
  }
});

//Slider UGC
const swiper4 = new Swiper('.swiper4', {
  slidesPerView: 1.5,
  spaceBetween: 9,
  loop: true,
  centeredSlides: true,
  watchOverflow: true, 
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 2.5,
    },
    930: {
      slidesPerView: 3,
      spaceBetween: 15,
      centeredSlides: false,
      pagination: false
    }
  }
});

// // //Slider tabs multicollección home
// // Inicializar el Swiper5
const swiper5 = new Swiper('.swiper5', {
  slidesPerView: 2,
  spaceBetween: 5.54,
  watchOverflow: true,
  loop: false,
  navigation: false, // Desactiva navegación en menores viewports
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    // Para pantallas por debajo de 787px (mobile)
    0: {
      // navigation: false, 
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 2,
      spaceBetween: 5.54,
    },
    // Para pantallas de 787px o más (tablet y desktop)
    787: {
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 'auto',
      spaceBetween: 15,
    },
  } 
});

